import React from 'react';
import styles from './SummaryCards.module.css';

export interface SummaryCardItem {
  label: string;
  value: React.ReactNode;
}

interface SummaryCardsProps {
  items: SummaryCardItem[];
  className?: string;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ items, className = '' }) => (
  <div className={`${styles.cards} ${className}`}>
    {items.map((item) => (
      <div key={item.label} className={styles.card}>
        <div className={styles.label}>{item.label}</div>
        <div className={styles.value}>{item.value}</div>
      </div>
    ))}
  </div>
);

export default SummaryCards;
